export const truncateLines = ({
  limit,
  maxHeight,
}: {
  limit: number;
  maxHeight: string;
}) => {
  return {
    display: '-webkit-box',
    maxHeight,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-line-clamp': limit,
    '-webkit-box-orient': 'vertical',
  };
};
